/**
 * Simplified Mobile Handler - v1.0.14
 *
 * Minimal iOS keyboard handling following industry standards.
 * Lets iOS Safari handle keyboard positioning naturally with flexbox.
 *
 * ONLY handles:
 * - iOS detection
 * - Zoom prevention (font-size: 16px)
 * - Optional hero hiding on focus (UX choice)
 */

export class MobileHandler {
  constructor() {
    // Simple iOS detection
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    console.log('[Mobile] Simplified handler initialized:', {
      isMobile: this.isMobile,
      isIOS: this.isIOS
    });
  }

  /**
   * Initialize mobile handler
   * @param {Element} chatPanel - The chat panel element
   */
  init(chatPanel) {
    if (!this.isMobile) {
      console.log('[Mobile] Desktop detected, skipping mobile optimizations');
      return;
    }

    const inputField = document.querySelector('.chat-input');
    if (!inputField) {
      console.log('[Mobile] No input field found');
      return;
    }

    // iOS zoom prevention - set font size to 16px minimum
    // This prevents iOS Safari from zooming when input is focused
    if (this.isIOS) {
      inputField.style.fontSize = '16px';
      console.log('[Mobile] iOS zoom prevention: Set font-size to 16px');
    }

    // Hero is now hidden via CSS on mobile (display: none in media query)
    // No need for JavaScript manipulation

    console.log('[Mobile] Initialization complete - using native iOS keyboard handling');
  }

  /**
   * Cleanup method (for consistency with old interface)
   */
  destroy() {
    // Nothing to clean up in simplified version
    console.log('[Mobile] Handler destroyed');
  }
}